import Vue from 'vue'
import Router from 'vue-router'
import { contextPath, cookieToken, routerMode } from '@/utils/global'
import 'nprogress/nprogress.css'
import NProgress from 'nprogress'

Vue.use(Router)
NProgress.configure({ showSpinner: false })

const router = new Router({
  mode: routerMode,
  base: contextPath,
  routes: [
    {
      path: '/',
      name: '首页',
      component: resolve => require(['@/views/Home'], resolve)
    },
    {
      path: '/article',
      name: '文章',
      component: resolve => require(['@/views/Details'], resolve)
    },
    {
      path: '*',
      name: 'notFound',
      component: resolve => require(['@/views/error/404'], resolve)
    }
  ]
})

/**
 * 前置路由
 */
router.beforeEach((to, from, next) => {
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js